import { render, staticRenderFns } from "./FormSubmitButton.vue?vue&type=template&id=40a90a84&scoped=true&"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmitButton.vue?vue&type=style&index=0&id=40a90a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a90a84",
  null
  
)

export default component.exports